import _ from "lodash";
import formatValue from "../ListUtils/FormatValue";
import React from "react";
import {Area, Bar, LabelList, Line} from "recharts";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../Components/JsonScreen/Utils/lib";

export const chartColors = [
    "#3366cc",
    "#dc3912",
    "#ff9900",
    "#109618",
    "#990099",
    "#0099c6",
    "#dd4477",
    "#66aa00",
    "#b82e2e",
    "#316395",
    "#3366cc",
    "#994499",
    "#22aa99",
    "#aaaa11",
    "#6633cc",
    "#e67300",
    "#8b0707",
    "#651067",
    "#329262",
    "#5574a6",
    "#3b3eac",
    "#b77322",
    "#16d620",
    "#b91383",
    "#f4359e",
    "#9c5935",
    "#a9c413",
    "#2a778d",
    "#668d1c",
    "#bea413",
    "#0c5922",
    "#743411"];
//find colors for series
export const findColor = (series, serieName) => {
    let customColor = false;
    series.forEach(serie => {
        if (serie.column === serieName) {
            customColor = serie.color
        }
    });
    return customColor;
};
//find style for series
export const findStyle = (series, serieName) => {
    let customStyle = false;
    series.forEach(serie => {
        if (serie.column === serieName) {
            customStyle = serie.style
        }
    });
    return customStyle;
};
//find type for serie for composed chart
export const findType = (series, serieName) => {
    let customType = 'bar';
    series.forEach(serie => {
        if (serie.column === serieName) {
            customType = serie.type
        }
    });
    return customType;
};

//customized label for pie chart
export const renderCustomizedLabel = (props, columns, valueColumn, showNameInLabel) => {
    const {value, textAnchor, fill, name, x, y} = props;
    const columnType = getColumnTypeById(columns, valueColumn);
    const columnFormat = getColumnById(columns, valueColumn).format;
    return (
        <>
            <text x={x} y={showNameInLabel ? y + 8 : y} textAnchor={textAnchor} dy={'0em'} fill={fill}>
                {value === undefined ? '' :
                    columnType === 'duration' ?
                        `${humanizeDuration(value, columnFormat)}` :
                        `${formatValue(value, columnType, columnFormat)}`
                }
            </text>
            {showNameInLabel && value !== undefined && (
                <text x={x} y={y - 6} fontSize={12} textAnchor={textAnchor} dy={'0em'} fill={fill}>
                    {name}
                </text>
            )}
        </>
    );
};
//duration format
export const isAllDuration = (columns) => {
    let isDuration = columns.filter((c) => c.type === 'duration');
    return !!(isDuration && isDuration.length > 0);
};
export const humanizeDuration = (milliseconds, format) => {
    // Pad to 2 or 3 digits, default is 2
    function pad(n, z) {
        z = z || 2;
        return ('00' + parseInt(n)).slice(-z);
    }

    let ms = milliseconds % 1000;
    milliseconds = (milliseconds - ms) / 1000;
    let secs = milliseconds % 60;
    milliseconds = (milliseconds - secs) / 60;
    let mins = milliseconds % 60;
    let hrs = (milliseconds - mins) / 60;
    let fullDuration = pad(hrs) + ':' + pad(mins) + ':' + pad(secs) + '.' + pad(ms, 3);
    if (format) {
        let splitFormat = format.split(':');
        let splitSsMs = splitFormat[2] ? splitFormat[2].split('.') : [];
        let isHH = splitFormat[0] === 'HH';
        let isMM = splitFormat[1] === 'MM';
        let isSS = splitSsMs[0] === 'SS';
        let isSSS = splitSsMs[1] === 'sss';
        if (isHH && isMM && isSS && isSSS) {
            return fullDuration
        } else if (isHH && !isMM) {
            return pad(hrs)
        } else if (isHH && isMM && !isSS) {
            return pad(hrs) + ':' + pad(mins)
        } else if (isHH && isMM && isSS && !isSSS) {
            return pad(hrs) + ':' + pad(mins) + ':' + pad(secs)
        } else {
            return fullDuration
        }
    }

    return fullDuration;
};

export const durationToMs = (duration) => {
    const splitedDuration = duration && duration.toString().split(':');
    const splitedSsMs = splitedDuration[2] ? splitedDuration[2].split('.') : [];
    const hh = Math.round(Number(splitedDuration[0] || 0) * 3.6 * 1000000);
    const mm = Number(splitedDuration[1] || 0) * 60 * 1000;
    const ss = Number(splitedSsMs[0] || 0) * 1000;
    const ms = Number(splitedSsMs[1] || 0);
    return hh + mm + ss + ms
};


//helpers
export const getColumnType = (columns, name) => {
    const column = columns.find(i => (typeof i.label === 'string' ? i.label : i.label?.en) === name);
    return column ? column.type : 'string'
};
export const getColumnTypeById = (columns, name) => {
    const column = columns.find(i => i.name === name);
    return column ? column.type : 'string'
};
export const getColumn = (columns, name) => {
    const column = columns.find(i => (typeof i.label === 'string' ? i.label : i.label?.en) === name);
    return column ? column : {}
};
export const getColumnById = (columns, name) => {
    const column = columns.find(i => i.name === name);
    return column ? column : {}
};


export const isAllInteger = (columns, indexBy) => {
    let isAllInteger = true;
    let newColumns = columns.filter((c) => c.name !== indexBy);
    newColumns.forEach(c => {
        if (c.type !== 'integer') {
            isAllInteger = false
        }
    });
    return isAllInteger;
};
export const transformData = (data = [], columns) => {
    let formattedContent = [];
    data.forEach(i => {
        if (i.__isGrandTotal) return; //check for grandTotal row
        let newI = {};
        Object.keys(i).forEach(j => {
            let column = _.find(columns, (o) => {
                return (o.name === j)
            }) || {};
            let isValidColumn = column.name && (column.name !== 'grandTotal');
            if (isValidColumn) { //check for existing column and grandTotal column
                newI[column.name] = column.type === 'date' ?
                    formatValue(i[j], column.type) :
                    column.type === 'duration' ?
                        durationToMs(i[j] || "00:00:00.000") :
                        i[j];
            }
        });
        formattedContent.push(newI)
    });
    return formattedContent;
};


export const renderChartItems = (props) => {
    const {
        columns,
        series,
        indexBy,
        lineStyle,
        enablePoints,
        enableLabel,
        userLanguage
    } = props;
    //order columns by type 1. line 2. bar 3. area
    let sortHelp = {
        line: 3,
        bar: 2,
        area: 1
    };
    const sortedColumns = _.sortBy(columns, (c) => {
        const customType = findType(series, c.name);
        return sortHelp[customType]
    });
    return (
        sortedColumns.map((c, i) => {
            const customColor = findColor(series, c.name);
            const customStyle = findStyle(series, c.name);
            const customType = findType(series, c.name);
            const multiLanguageLabel = multiLanguageValue(c.label, userLanguage)
            switch (customType) {
                case "line":
                    if (c.name !== 'grandTotal' && c.name !== indexBy && !c.hidden) {
                        return (
                            <Line key={`${c.name}_${i}`}
                                  connectNulls
                                  onClick={(obj) => this.onLineClick(obj, c.name)}
                                  type={customStyle ? customStyle : lineStyle}
                                  dataKey={c.name}
                                  dot={enablePoints}
                                  animationDuration={300}
                                  name={multiLanguageLabel}
                                  stroke={customColor ? customColor : chartColors[i % chartColors.length]}
                                  activeDot={{r: 5}}/>
                        )
                    }
                    break;
                case 'bar':
                    if (c.name !== 'grandTotal' && c.name !== indexBy && !c.hidden) {
                        return (
                            <Bar key={`${c.name}_${i}`}
                                 stackId={'a'}
                                 onClick={(obj) => this.onLineClick(obj, c.name)}
                                 dataKey={c.name}
                                 animationDuration={300}
                                 name={multiLanguageLabel}
                                 fill={customColor ? customColor : chartColors[i % chartColors.length]}>
                                {enableLabel && (
                                    <LabelList
                                        formatter={(value) => {
                                            return isAllDuration ? humanizeDuration(value, c.format) : formatValue(value, 'number', undefined)
                                        }}
                                        dataKey={c.name}
                                        position="center"/>
                                )}
                            </Bar>
                        )
                    }
                    break;
                case 'area':
                    if (c.name !== 'grandTotal' && c.name !== indexBy && !c.hidden) {
                        return (
                            <Area key={`${c.name}_${i}`}
                                  dataKey={c.name}
                                  animationDuration={300}
                                  type={customStyle ? customStyle : lineStyle}
                                  name={multiLanguageLabel}
                                  stroke={customColor ? customColor : chartColors[i % chartColors.length]}
                                  fill={customColor ? customColor : chartColors[i % chartColors.length]}
                            >
                            </Area>
                        )
                    }
                    break;
                default:
                    if (c.name !== 'grandTotal' && c.name !== indexBy && !c.hidden) {
                        return (
                            <Line key={`${c.name}_${i}`}
                                  connectNulls
                                  onClick={(obj) => this.onLineClick(obj, c.name)}
                                  type={customStyle ? customStyle : lineStyle}
                                  dataKey={c.name}
                                  dot={enablePoints}
                                  animationDuration={300}
                                  name={multiLanguageLabel}
                                  stroke={customColor ? customColor : chartColors[i % chartColors.length]}
                                  activeDot={{r: 5}}/>
                        )
                    }
                    break;
            }
            return null
        })
    )
};